export default __webpack_public_path__ + "static/media/me.aed03aa5.jpg";